"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
//@todo make it smarter, let it know what those placeholders are -> better interface
var StringWrapper = /** @class */ (function () {
    function StringWrapper(val) {
        var _this = this;
        this.withoutPostfix = function (postfix) {
            var isValid = (_this.value.length >= postfix.length);
            var result = isValid && _this.value.substr(0, _this.value.length - postfix.length) || _this.value;
            return new StringWrapper(result);
        };
        this.withoutPrefix = function (prefix) {
            var result = _this.value.length >= prefix.length && _this.value.substr(prefix.length) || _this.value;
            return new StringWrapper(result);
        };
        this.value = val;
    }
    StringWrapper.prototype.startsWith = function (val) {
        return !!this.value && !!val && (val.length <= this.value.length) && (this.value.substr(0, val.length) === val);
    };
    StringWrapper.prototype.endsWith = function (val) {
        var result = !!this.value &&
            !!val &&
            (val.length <= this.value.length) &&
            (this.value.substr(this.value.length - val.length) === val);
        return result;
    };
    StringWrapper.prototype.toString = function () {
        return this.value;
    };
    return StringWrapper;
}());
exports.StringWrapper = StringWrapper;
